import { Controller } from "@hotwired/stimulus"

// Landing: menu mobile (mobileOpen di Landing.js) e chiusura del banner dell'apertura (bannerDismissed).
export default class extends Controller {
  static targets = ["menu", "iconaMenu", "iconaChiudi", "banner"]

  toggleMenu() {
    this.imposta(this.menuTarget.hidden)
  }

  chiudiMenu() {
    this.imposta(false)
  }

  chiudiBanner() {
    this.bannerTargets.forEach((b) => b.remove())
  }

  imposta(aperto) {
    this.menuTarget.hidden = !aperto
    this.iconaMenuTarget.hidden = aperto
    this.iconaChiudiTarget.hidden = !aperto
  }
}
